/*
 * Подписи и склейка ленты. Вынесено из компонента, чтобы проверялось
 * тестами: даты и группировка ломаются молча и заметны не сразу.
 */

export function dayLabel(ts: number, now = Date.now()): string {
  const d = new Date(ts * 1000);
  const today = new Date(now);
  const yesterday = new Date(now - 86400_000);
  const same = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  if (same(d, today)) return 'Сегодня';
  if (same(d, yesterday)) return 'Вчера';
  const sameYear = d.getFullYear() === today.getFullYear();
  return d.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

/** Время в строке списка чатов: коротко и без лишних слов. */
export function listTime(ts: number, now = Date.now()): string {
  const d = new Date(ts * 1000);
  const today = new Date(now);
  const sameDay = d.toDateString() === today.toDateString();
  if (sameDay) return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  const yesterday = new Date(now - 86400_000);
  if (d.toDateString() === yesterday.toDateString()) return 'вчера';
  const sameYear = d.getFullYear() === today.getFullYear();
  return d.toLocaleDateString('ru-RU', sameYear ? { day: 'numeric', month: 'short' } : { year: '2-digit', month: '2-digit', day: '2-digit' });
}

/**
 * Когда уведомление пришло — для списка колокольчика, где событий мало и они
 * не разбиты по дням: сегодняшнее показывает одно время, вчерашнее и старше —
 * ещё и день.
 */
export function notifyTime(ts: number, now = Date.now()): string {
  const d = new Date(ts * 1000);
  const time = d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  const today = new Date(now);
  if (d.toDateString() === today.toDateString()) return time;
  if (d.toDateString() === new Date(now - 86400_000).toDateString()) return `вчера, ${time}`;
  const sameYear = d.getFullYear() === today.getFullYear();
  const day = d.toLocaleDateString(
    'ru-RU',
    sameYear ? { day: 'numeric', month: 'short' } : { day: '2-digit', month: '2-digit', year: '2-digit' },
  );
  return `${day}, ${time}`;
}

export const timeLabel = (ts: number): string =>
  new Date(ts * 1000).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

export const fileSize = (bytes: number): string =>
  bytes < 1024
    ? `${bytes} Б`
    : bytes < 1024 * 1024
      ? `${Math.round(bytes / 1024)} КБ`
      : `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;

/** Сообщения одного автора подряд склеиваются в группу — но не через день. */
export const GROUP_WINDOW_S = 300;

export function isGrouped(
  current: { author: { login: string }; ts: number },
  previous: { author: { login: string }; ts: number } | undefined,
  newDay: boolean,
): boolean {
  if (!previous || newDay) return false;
  return (
    current.author.login === previous.author.login && current.ts - previous.ts < GROUP_WINDOW_S
  );
}

export const replyCountLabel = (n: number): string => {
  const a = n % 10;
  const b = n % 100;
  if (a === 1 && b !== 11) return `${n} ответ`;
  if (a >= 2 && a <= 4 && (b < 10 || b >= 20)) return `${n} ответа`;
  return `${n} ответов`;
};
